import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { Http, Headers, URLSearchParams } from "@angular/http";
import "rxjs/add/operator/toPromise";
import { CookieService } from "ngx-cookie-service";
import { BaseService } from "../base.service";

@Injectable()
export class LoginService extends BaseService {
  constructor(http: Http, cookieService: CookieService) {
    super(http, cookieService);
  }

  login(magicLink, email) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", magicLink);

    return this.http
      .get(environment["API_HOST"] + "/decode-magic-link", { headers: headers })
      .toPromise()
      .then(response => {
        let resJSON = response.json();

        if (localStorage) {
          localStorage.setItem("magic_link", magicLink);
          localStorage.setItem("user_details", JSON.stringify(resJSON));
          localStorage.setItem("list_name", resJSON.list_name);
          localStorage.setItem("user_id", resJSON.user_id);
          localStorage.setItem("season", resJSON.season);
          if (email && email != "") {
            localStorage.setItem("cust_email", email);
          } else {
            localStorage.setItem("cust_email", resJSON.email);
          }
        }
        if (resJSON && resJSON["token"]) {
          this.setCookie("token", resJSON["token"]);
        }
        return Promise.resolve(resJSON);
      });
  }

  isLoggedIn() {
    return new Promise((resolve, reject) => {
      try {
        let userDetails = JSON.parse(localStorage.getItem("user_details"));
        // var identity = heap.identity;
        // if (!identity) {
        //   this.setHeap(userDetails);
        // }

        if (
          userDetails["email"] &&
          userDetails["list_name"] &&
          userDetails["season"] &&
          userDetails["user_id"]
        ) {
          return resolve(userDetails);
        } else {
          return reject(new Error("Not logged in..."));
        }
      } catch (e) {
        console.error(e);
        return reject(new Error("Not logged in..."));
      }
    });
  }
  // setHeap(user) {
  //   heap.identify(user.email);

  //   let userProperties = {
  //     season: user.season,

  //     email: user.email,
  //     list_name: user.list_name
  //   };

  //   // heap.addUserProperties(userProperties);
  // }

  logout() {
    if (localStorage) {
      localStorage.clear();
    }
    return Promise.resolve();
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.service.ts